// extracted by mini-css-extract-plugin
export default {"form":"Consultation_form__AwHFZ","message":"Consultation_message__BwKm5","bn13":"Consultation_bn13__lB3K6","bn13bouncy":"Consultation_bn13bouncy__IGEdf"};